<div fxLayout="column" fxLayoutAlign="start start">
    <div *ngIf="isShowDocumentMode" style="width: 100%;">
        <div fxLayout="row" fxLayoutAlign="end">
            <forge-button aria-label="Hide" (click)="hide()">
                <forge-icon name="visibility_off"></forge-icon>
                    Hide
                </forge-button>
        </div>
        <iframe style="height: 849px; width: 100%; border: 1px solid var(--forge-theme-text-lowest, rgba(0,0,0,0.12)); border-top: none;" [src]="documentUrl"></iframe>
    </div>
    <div *ngIf="!isShowDocumentMode" fxLayout="row" fxLayoutAlign="start center" class="file-picker-container" [ngClass]="{'invalid': isInvalid}">
        <div>
            <forge-label-value [attr.telemetry]="telemetryLabel">
                <span slot="label" [ngClass]="{'file-required': isRequired}">{{label}}</span>
                <span slot="value" fxLayout="row">
                    <div fxLayout="column" fxLayoutAlign="center center">
                        <forge-file-picker [disabled]="isViewOnly" [attr.accept]="allowedTypes" [attr.multiple]="allowMultiple" [attr.compact]="!showDragDrop ? '' : undefined" [attr.max_size]="maxSize" (forge-file-picker-change)="onFileSelected($event)">
                            <span slot="primary">{{primaryMessage}}</span>
                            <span slot="secondary">
                                Maximum file size: {{formatMaxSize}}
                                <span *ngIf="showTypeField"><br>({{allowedTypesView}})</span>
                            </span>
                            <forge-button variant="outlined" [dense]="compact">
                                {{buttonMessage}}
                            </forge-button>
                        </forge-file-picker>

                        <div *ngIf="filesExist && allowMultiple" style="width: 100%;">
                            <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%;" *ngFor="let file of valueModel">
                                <span class="file-list--item forge-typography--label1">{{file.FileName}}</span>
                                <forge-icon-button *ngIf="!isViewOnly" dense telemetry="Submission-Clear" (click)="clear(file)">
                                    <forge-tooltip>Remove '{{file.FileName}}'</forge-tooltip>
                                    <forge-icon name="close"></forge-icon>
                                </forge-icon-button>
                            </div>
                        </div>
                        <div *ngIf="filesExist && !allowMultiple" fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%;">
                            <span class="file-list--item forge-typography--label1">{{valueModel.FileName}}</span>
                            <forge-icon-button *ngIf="!isViewOnly" dense telemetry="Clear" (click)="clear(null)">
                                <forge-tooltip>Remove '{{valueModel.FileName}}'</forge-tooltip>
                                <forge-icon name="close"></forge-icon>
                            </forge-icon-button>
                        </div>
                        <forge-divider *ngIf="badFileList.length > 0 && allowMultiple && filesExist" style="width: 100%; margin: .5rem;">
                        </forge-divider>
                        <div fxLayout="row" fxLayoutAlign="space-between center" style="width: 100%;" *ngFor="let file of badFileList">
                            <div fxLayout="column" fxLayoutAlign="start start">
                                <span class="file-list--item forge-typography--label1">{{file.FileName}}</span>
                                <span class="forge-typography--label1 tyl-color-danger" style="margin-top: -0.25rem;">{{file.Message}}</span>
                            </div>
                            <forge-icon name="error" external="true" slot="trailing" class="tyl-color-danger" id="true">
                            </forge-icon>
                        </div>
                        <div *ngIf="isDownloadable || isShowable" fxLayout="column" fxLayoutAlign="start center" style="width: 100%;">
                            <forge-divider style="width: 100%; margin: .5rem;"></forge-divider>
                            <div fxLayout="row" fxLayoutAlign="center center">
                                <forge-button *ngIf="isDownloadable" telemetry="Submission-Download" (click)="download()">
                                    <forge-icon name="download"></forge-icon>
                                        Download
                                </forge-button>
                                <forge-button *ngIf="isShowable" aria-label="Show" (click)="show()">
                                    <forge-icon name="visibility"></forge-icon>
                                        Show
                                </forge-button>
                            </div>
                        </div>
                    </div>
                </span>
            </forge-label-value>
            <div *ngIf="isInvalid" class="forge-typography--label1 error-red">Please select a file.</div>
        </div>
    </div>
</div>
